module.exports = function findLocalCartItems() {
	return typeof window !== "undefined" && window.localStorage.getItem("cart_items")
		? JSON.parse(window.localStorage.getItem("cart_items"))
		: [];
};
